import _ from 'lodash';
import React from 'react';

import { RegieContext } from '@/contexts';
import {
  type BordereauRemiseContextType,
  getBordereauRemiseContext,
} from '@/contexts/BordereauRemiseContext';
import useListeSearchSort from '@/hooks/useListeSearchSort';
import { getBordereaux } from '@/routes';
import type { Bordereau, ModeReglementsPointageType } from '@/types';

type BordereauRemiseContextProviderProps = {
  children: React.ReactNode;
  code: ModeReglementsPointageType;
};

const BordereauRemiseContextProvider = (props: BordereauRemiseContextProviderProps) => {
  const { children, code } = props;

  const { selectedRegie } = React.useContext(RegieContext);

  // Obtient le contexte spécifique pour ce code
  const SpecificContext = React.useMemo(() => getBordereauRemiseContext(code), [code]);

  const {
    items,
    setItems,
    setPage,
    loading,
    sorts,
    setSorts,
    filters,
    setFilters,
    total,
    setTotal,
    reset,
  } = useListeSearchSort({
    active: !_.isNil(selectedRegie),
    getItems: getBordereaux,
    fixedParams: { codeModeReglement: code },
  });

  const currentContext = React.useMemo<BordereauRemiseContextType>(
    () => ({
      total,
      bordereaux: items as Bordereau[],
      filters,
      sorts,
      loading,
      setBordereaux: setItems,
      setFilters,
      setSorts,
      setPage,
      setTotal,
      reset,
    }),
    [
      total,
      items,
      filters,
      sorts,
      loading,
      setItems,
      setFilters,
      setSorts,
      setPage,
      setTotal,
      reset,
    ],
  );

  return <SpecificContext.Provider value={currentContext}>{children}</SpecificContext.Provider>;
};

export default BordereauRemiseContextProvider;
